export default {
	firestorePath: "projects",
	firestoreRefType: "collection",
	moduleName: "projects",
	statePropName: "data",
	namespaced: true,
	state: {},
	getters: {},
	serverChange: {
	},
	mutations: {},
	actions: {
	},
};
